module.exports = __webpack_public_path__ + "media/3x/F-5e9c017b.png";